<template>
  <div class="supply-dashboard">
    <h1>Exemplos de gráficos</h1>
    <div class="charts">
      <div class="chart">
        <h3>Bar Chart</h3>
        <BarEChart />
      </div>

      <div class="chart">
        <h3>Line Chart</h3>
        <LineEChart />
      </div>

      <div class="chart">
        <h3>Pie Chart</h3>
        <PieEChart />
      </div>

      <div class="chart">
        <h3>Scatter Chart</h3>
        <ScatterEChart />
      </div>

      <div class="chart">
        <h3>Tree Chart</h3>
        <TreeEChart />
      </div>

      <div class="chart">
        <h3>Radar Chart</h3>
        <RadarEChart />
      </div>

      <div class="chart">
        <h3>Gauge Chart</h3>
        <GaugeEChart />
      </div>

      <div class="chart">
        <h3>Boxplot Chart</h3>
        <BoxsplotEChart />
      </div>

      <div class="chart">
        <h3>Map Chart</h3>
        <MapEChart />
      </div>

      <div class="chart">
        <h3>Heatmap Chart</h3>
        <HeatmapEChart />
      </div>

      <div class="chart">
        <h3>Parallel Chart</h3>
        <ParallelEChart />
      </div>

      <div class="chart">
        <h3>Sankey Chart</h3>
        <SankeyEChart />
      </div>

      <div class="chart">
        <h3>Funnel Chart</h3>
        <FunnelEChart />
      </div>

      <div class="chart">
        <h3>Graph Chart</h3>
        <GraphEChart />
      </div>

      <div class="chart">
        <h3>Calendar Chart</h3>
        <CalendarEChart />
      </div>

      <div class="chart">
        <h3>PictorialBar Chart</h3>
        <PictorialBarEChart />
      </div>

      <div class="chart">
        <h3>Polar Chart</h3>
        <PolarEChart />
      </div>

      <div class="chart">
        <h3>Sunburst Chart</h3>
        <SunburstEChart />
      </div>

      <div class="chart">
        <h3>PhaseDiagram Chart</h3>
        <PhaseDiagramEChart />
      </div>
    </div>
  </div>
</template>

<script>
import BarEChart from "./Charts/BarEChart.vue";
import LineEChart from "./Charts/LineEChart.vue";
import PieEChart from "./Charts/PieEChart.vue";
import ScatterEChart from "./Charts/ScatterEChart.vue";
import TreeEChart from "./Charts/TreeEChart.vue";
import RadarEChart from "./Charts/RadarEChart.vue";
import GaugeEChart from "./Charts/GaugeEChart.vue";
import BoxsplotEChart from "./Charts/BoxsplotEChart.vue";
import MapEChart from "./Charts/MapEChart.vue";
import HeatmapEChart from "./Charts/HeatmapEChart.vue";
import ParallelEChart from "./Charts/ParallelEChart.vue";
import SankeyEChart from "./Charts/SankeyEChart.vue";
import FunnelEChart from "./Charts/FunnelEChart.vue";
import GraphEChart from "./Charts/GraphEChart.vue";
import CalendarEChart from "./Charts/CalendarEChart.vue";
import PictorialBarEChart from "./Charts/PictorialBarEChart.vue";
import PolarEChart from "./Charts/PolarEChart.vue";
import SunburstEChart from "./Charts/SunburstEChart.vue";
import PhaseDiagramEChart from "./Charts/PhaseDiagramEChart.vue";

export default {
  name: "SupplyDashboard",
  components: {
    BarEChart,
    LineEChart,
    PieEChart,
    ScatterEChart,
    TreeEChart,
    RadarEChart,
    GaugeEChart,
    BoxsplotEChart,
    MapEChart,
    HeatmapEChart,
    ParallelEChart,
    SankeyEChart,
    FunnelEChart,
    GraphEChart,
    CalendarEChart,
    PictorialBarEChart,
    PolarEChart,
    SunburstEChart,
    PhaseDiagramEChart
  }
};
</script>

<style scoped>
.supply-dashboard {
  padding: 20px;
}

.charts {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.chart {
  flex: 1;
}

.chart h3 {
  text-align: left;
}

.chart > * {
  width: 100%;
}
</style>
